import { DeleteAtomModal } from './DeleteAtomModal'

export default DeleteAtomModal
